import { HttpResponse } from '@angular/common/http';

export function downloadFileFromResponse(response: HttpResponse<Blob>) {
  const responseBlob = response.body!;
  const contentDisposition = response.headers.get('content-disposition');

  let fileName = '';
  if (contentDisposition !== null) {
    fileName = getFileNameFromContentDisposition(contentDisposition);
  }
  downloadFileFromBlob(responseBlob, fileName);
}

export function downloadFileFromBlob(responseBlob: Blob, fileName: string) {
  const blob = new Blob([responseBlob], { type: responseBlob.type.toString() });
  const blobUrl = window.URL.createObjectURL(blob);

  const a = document.createElement('a');
  a.href = blobUrl;
  a.download = fileName;

  a.dispatchEvent(new MouseEvent('click'));

  window.URL.revokeObjectURL(blobUrl);
}

function getFileNameFromContentDisposition(contentDisposition: string): string {
  const fileNameMatch = contentDisposition.match(/filename\*?=(?:UTF-8'')?["']?([^"';]+)["']?/i);
  return fileNameMatch ? decodeURIComponent(fileNameMatch[1]) : '';
}

export function computeFileName(fileNamePrefix: string, requestId: string, fileType: string): string {
  const now = new Date();
  const formattedDate = new Intl.DateTimeFormat('en-US', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  })
    .format(now)
    .replace(/[/,:\s]/g, '_');

  return requestId !== ''
    ? `${fileNamePrefix}_${requestId}_${formattedDate}.${fileType}`
    : `${fileNamePrefix}_${formattedDate}.${fileType}`;
}